import { Controller } from "@hotwired/stimulus"

// Toggles the per-conversion-action subrows for an entity row in the campaigns
// table. The expander button passes the entity id; subrows carry a matching
// data-breakdown-key and start hidden.
export default class extends Controller {
  toggle(event) {
    const key = event.params.key
    this.element
      .querySelectorAll(`[data-breakdown-key="${key}"]`)
      .forEach((row) => row.classList.toggle("hidden"))

    const chevron = event.currentTarget.querySelector("[data-breakdown-chevron]")
    if (chevron) chevron.classList.toggle("rotate-90")
  }
}
